import { AxiosResponse } from "axios";
import { After10ApiError, After10ApiResponse, RequestProps } from "./types";
import axiosInstance from "./axios";
import qs from "qs";
import { useErrorStore } from "stores/errorStore";
import { getApiErrorResult } from "./method";

export async function apiRequest<T>(
  requestParams: RequestProps,
): Promise<AxiosResponse> {
  const setError = useErrorStore.getState().setError;
  const tmpUrl = requestParams.url;

  const obj = {
    ...requestParams,
    url: tmpUrl && tmpUrl.startsWith("/") ? `${tmpUrl}` : `/${tmpUrl}`,
  };

  let {
    url,
    method,
    isFileUpload,
    isErrorAlert = true,
    params,
    data,
    paramsSerializer,
  } = obj;
  let headers = undefined;
  if (method === "GET") {
    if (!paramsSerializer) {
      paramsSerializer = (objParams): string => {
        return qs.stringify(objParams, {
          arrayFormat: "repeat",
          skipNulls: true,
        }); // array 포맷 변환 및 null값 제외 처리
      };
    }
  } else {
    const objData = data || params;

    if (isFileUpload) {
      headers = { "Content-Type": "multipart/form-data" };
      if (objData) {
        data = new FormData();

        Object.keys(objData).forEach((key) => {
          const value = objData[key];
          if (value) {
            if (Array.isArray(value)) {
              value.forEach((val) => {
                data.append(key, val);
              });
            } else {
              data.append(key, value);
            }
          }
        });
      }
    } else {
      data = objData
        ? qs.stringify(objData, { arrayFormat: "repeat", skipNulls: true })
        : undefined; // GET이 아닐때는 data로 넘겨줘야됨
    }
    params = undefined;

    if (!headers || !headers["Content-Type"]) {
      headers = {
        ...headers,
        "Content-Type": "application/x-www-form-urlencoded",
      };
    }
  }

  return axiosInstance
    .request<T>({
      url,
      method,
      data: data,
      params,
      paramsSerializer,
      headers,
    })
    .then((response: AxiosResponse) => {
      return response;
    })
    .catch((error) => {
      const errorResult = getApiErrorResult(error);
      if (isErrorAlert) {
        setError(errorResult);
      }
      return Promise.reject(error);
    });
}

export function request<T = any>(obj: RequestProps): Promise<T> {
  const { isErrorAlert = true } = obj;

  const requestObj: RequestProps = {
    ...obj,
    isErrorAlert,
  };

  return apiRequest(requestObj)
    .then((response: After10ApiResponse<T>) => response.data.result)
    .catch((error: After10ApiError) => Promise.reject(error));
}

export function getRequest<T = unknown>(obj: RequestProps): Promise<T> {
  return request<T>({ ...obj, method: "GET" });
}

export function postRequest<T = unknown>(obj: RequestProps): Promise<T> {
  return request({ ...obj, method: "POST" });
}

export function putRequest<T = any>(obj: RequestProps): Promise<T> {
  return request({ ...obj, method: "PUT" });
}

export function deleteRequest<T = any>(obj: RequestProps): Promise<T> {
  return request({ ...obj, method: "DELETE" });
}
